<template>
    <div>
        <v-offline online-class="online" offline-class="offline" @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <el-row class="setMarginTop">
            <el-col>
                <div class="panel-heading">
                    <h5>Records > Catch Release > Map {{ activeAreaName }}</h5>
                    <hr>
                </div>
            </el-col>
        </el-row>
        <div class="row set_div_map">
            <div class="col-sm-12">
                <p style="margin-bottom: 10px;margin-top: 4px;">Filters</p>
            </div>
            <div v-bind:class="datePickerStyleClass">
                <span @click="showModal = false">
                    <v-md-date-range-picker class="datepicker" v-show="filterByDate" :presets="dateRangePresets"
                        :start-date="startDatePast" :end-date="endDatePast"
                        @change="handleChange"></v-md-date-range-picker>
                    <el-checkbox v-model="filterByDate">Date Range</el-checkbox>
                </span>
            </div>
            <div class="col-xs-12 col-md-2 col-xl-2">
                <fg-input type="text" placeholder="HSIApps Animal ID" name="uniqueid" value=""
                    v-model="uniqueid"></fg-input>
            </div>
            <div class="col-xs-12 col-md-3 col-xl-3">
                <fg-input type="text" placeholder="RFID" name="rfid" v-model="rfid"></fg-input>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-xs-12 col-md-3 col-xl-1">
                <button v-bind:disabled="!onLine" type="button" class="btn btn-primary" @click="getRecords()">Filter
                </button>
            </div>
            <div class="col-xs-12 col-md-3 col-xl-1">
                <button v-bind:disabled="!onLine" type="button" class="btn btn-warning" @click="clearFilters()">Clear
                    Filters
                </button>
            </div>
        </div>
        <br>
        <div class="card setShadow set_redius set_div_maps" v-if="showModal">
            <div class="card-body" style="text-align: center; background-color: #eee">
                <button type="button" class="close close_modal" @click="showModal = false">
                    <span class="close-icon" aria-hidden="true">&times;</span>
                </button>
                <p style="margin-bottom: 10px;"><img :src="image_url" style="height: 80px;width: 80px;" /></p>
                <div class="set_p_btn">
                    <span class="span_font">App ID</span>
                    <p class="p_font">{{ hsapps_id }}</p>
                </div>
                <div class="set_p_btn">
                    <span class="span_font">RF - ID</span>
                    <p class="p_font">{{ rf_id }}</p>
                </div>
                <div class="set_p_btn">
                    <span class="span_font">Gender</span>
                    <p class="p_font">{{ gender }}</p>
                </div>
                <div class="set_p_btn">
                    <span class="span_font">Last detail Location</span>
                    <p class="p_font">{{ caught_location }}</p>
                </div>
                <div class="set_p_btn">
                    <span class="span_font">Caught Date</span>
                    <p class="p_font">{{ caught_date }}</p>
                </div>
                <div class="set_p_btn">
                    <span class="span_font">Animal Type</span>
                    <p class="p_font">{{ animal_type }}</p>
                </div>
                <div class="set_p_btn">
                    <span class="span_font">Lactating/Young</span>
                    <p class="p_font">{{ reproductive_status }}</p>
                </div>
                <div class="set_p_btn">
                    <span class="span_font">Note</span>
                    <p class="p_font">{{ (note != '' ? note : '-NA-') }}</p>
                </div>
            </div>
        </div>
        <div class="row setMarginTop">
            <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
                <div class="card setShadow">
                    <div class="card-body" style="padding: 10px;">
                        <div class="legend-div">
                            <label class="label-color" style="background-color: #0000ff;"></label>
                            <span class="type-span">Male</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label class="label-color" style="background-color: #fff600;"></label>
                            <span class="type-span">Female</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label class="label-color" style="background-color: #ff0000;"></label>
                            <span class="type-span">Female Lactating</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label class="label-color" style="background-color: #808080;"></label>
                            <span class="type-span">Unknown</span>
                        </div>
                        <MapBase
                            v-if="isDataLoaded"
                            :enableCluster="true"
                            :enableKml="true"
                            :kmlFiles="layers"
                            :pins="markers"
                            :zoom="5"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-sm-12">
                <p>Found total {{ markers.length }} record(s).</p>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '../../../../../mixins/GlobalMixin';
import dateRangeDefaultPresetsMixin from '../../../../../mixins/DateRangeDefaultPresetsMixin';
import AreaCard from "../../../UIComponents/Cards/AreaCard.vue";
import { Row, Col, Checkbox } from 'element-ui';
import VOffline from 'v-offline';
import Vue from 'vue';
import VMdDateRangePicker from "v-md-date-range-picker";
import MapBase from '../../../../map/MapBase.vue';

Vue.use(VMdDateRangePicker);

export default {
    components: {
        "area-card": AreaCard,
        [Checkbox.name]: Checkbox,
        [Row.name]: Row,
        [Col.name]: Col,
        VOffline,
        MapBase
    },
    props: {
        projectId: {
            type: [String, Number],
        },
        areaId: {
            type: [String, Number],
        }
    },
    data() {
        return {
            datePickerStyleClass: 'col-xs-12 col-md-2 col-xl-2',
            filterByDate: false,
            country: '',
            selectedAreaId: "",
            project: null,
            area: [],
            startDate: '',
            endDate: '',
            markers: [],
            layers: [],
            center: { lat: 33.8291523, lng: -116.8004315 },
            showModal: false,
            uniqueid: '',
            rfid: '',
            //Details popup Start
            image_url: '',
            hsapps_id: '',
            rf_id: '',
            gender: '',
            caught_location: '',
            caught_date: '',
            animal_type: '',
            reproductive_status: '',
            note: '',
            ownerInfo: '',
            startDatePast: '',
            endDatePast: '',
            //Details popup End
            countryArr: [],
            stateArr: [],
            cityArr: [],
            activeAreaName: '',
            dateRangePresets: [],
            isDataLoaded: false
        }
    },
    mixins: [mixin, dateRangeDefaultPresetsMixin],
    methods: {
        markersclick(pinDetail) {
            this.showModal = true;
            this.image_url = pinDetail.image_url;
            this.hsapps_id = pinDetail.hsapps_id;
            this.rf_id = pinDetail.rf_id;
            this.gender = pinDetail.gender;
            this.caught_location = pinDetail.caught_location;
            this.caught_date = pinDetail.caught_date;
            this.animal_type = pinDetail.species;
            this.reproductive_status = pinDetail.reproductive_status;
            this.note = pinDetail.note;
        },
        handleChange(values) {
            var sDate = this.formatDate(values[0]._d);
            var eDate = this.formatDate(values[1]._d);
            this.startDate = sDate;
            this.endDate = eDate;
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        getArea() {
            axios.get("/area?project_id=" + this.projectId)
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        this.area = response.data.response.data;
                        this.plotAllKmlLayers(this.area);
                        var data = response.data.response.data;
                        data.map((item) => {
                            this.countryArr.push(item.google_country);
                            this.stateArr.push(item.google_admin_area_level1);
                            this.cityArr.push(item.google_locality);
                        });
                        let uNames = {};
                        this.countryArr.forEach(n => {
                            let lower = n.toLowerCase();
                            if (!uNames[lower]) {
                                uNames[lower] = n;
                            }
                        });

                        this.countryArr = Object.values(uNames);

                        var uniqueState = this.stateArr.filter(function (elem, index, self) {
                            if (elem != null && elem != "null") {
                                return index === self.indexOf(elem);
                            }
                        });
                        var uniqueCity = this.cityArr.filter(function (elem, index, self) {
                            if (elem != null && elem != "null") {
                                return index === self.indexOf(elem);
                            }
                        });
                        this.stateArr = uniqueState;
                        this.cityArr = uniqueCity;
                    }
                })
                .catch(error => {
                    console.log("🚀 ~ error:", error)
                    
                });
        },
        clearFilters() {
            let vm = this;
            vm.startDate = '';
            vm.endDate = '';
            vm.uniqueid = '';
            vm.selectedAreaId = '';
            vm.rfid = '';
            vm.getRecords();
        },
        getRecords() {
            const vm = this;
            vm.getPmFilterRecords();
        },
        pushMarkersOnMap(gender = '', age_category = '', reproductiveStatus = '') {
            gender = gender.toLowerCase();
            age_category = age_category.toLowerCase();
            reproductiveStatus = reproductiveStatus.toLowerCase();

            if (gender === 'female' && reproductiveStatus === 'lactating') {
                return { icon: "https://hsapps-prod-media.s3.amazonaws.com/dog_markers/red_dog.png" };
            }

            const iconMap = {
                male: "https://hsapps-prod-media.s3.amazonaws.com/dog_markers/blue_dog.png",
                female: "https://hsapps-prod-media.s3.amazonaws.com/dog_markers/yellow_dog.png",
                unknown: "https://hsapps-prod-media.s3.amazonaws.com/dog_markers/grey_dog.png"
            };

            return { icon: iconMap[gender] || iconMap.unknown };
        },
        plotAllKmlLayers() {
            var vm = this;
            vm.layers = [];

            vm.project.areas.forEach(area => {
                vm.layers.push(area.file_url);
            });
        },
        setMapCenter(location) {
            let latLng = location.split(',');
            var latitude = latLng[0];
            var longitude = latLng[1];

            this.center = {
                lat: parseFloat(latitude),
                lng: parseFloat(longitude)
            };
        },
        getPmFilterRecords() {
            let vm = this;
            vm.markers = [];
            axios.get('/catch_release/get_records/filter/' + this.areaId, {
                params: {
                    start_date: vm.startDate,
                    end_date: vm.endDate,
                    hsapps_id: vm.hsappsId,
                    rfid: vm.rfid,
                }
            }).then(response => {
                if (response.data.response.error.error_code == 0) {
                    vm.uniqueid = '';
                    vm.rfid = '';
                    const records = response.data.response.data.records;
                    const recordCount = records.length;
                    for (let j = 0; j < records.length; j++) {
                        const caught_location = records[j].caught_location;
                        const latLng = caught_location.split(',');
                        const latitude = parseFloat(latLng[0]);
                        const longitude = parseFloat(latLng[1]);
                        const gender = records[j].gender;
                        const age_category = records[j].age_category;
                        const details = records[j];
                        details.reproductive_status = details.reproductive_status || '';
                        const recordMapping = {
                            image_url: details.image_url,
                            hsapps_id: details.hsapps_id,
                            rf_id: details.rf_id,
                            gender: gender,
                            caught_location: details.caught_location,
                            caught_date: details.caught_date,
                            type: details.type,
                            reproductive_status: details.reproductive_status,
                            note: details.note,
                            vaccine_assistant: details.vaccine_assistant,
                            species: details.species
                        }
                        const iconData = vm.pushMarkersOnMap(
                            recordMapping.gender,
                            details.age_category,
                            details.reproductive_status
                        );

                        if (!iconData) return;

                        vm.markers.push({
                            lat: latitude,
                            lng: longitude,
                            markerConfig: {
                                iconUrl: iconData.icon,
                                popupConfig: { minWidth: 400 }
                            },
                            popupText: vm.generatePopupText(recordMapping)
                        });
                    }
                     vm.isDataLoaded = true;
                    if (recordCount == 0) {
                        alert("No records found in this area!");
                    }
                }
            });
        },
        generatePopupText(record) {
            return `
                <div style="display:flex;align-items:flex-start;gap:10px">
                    <img src="${record.image_url}" style="width:150px;height:150px;object-fit:cover;padding:5px">
                    <table>
                        <tr><td><strong>App ID:</strong></td><td>${record.hsapps_id}</td></tr>
                        <tr><td><strong>RF-ID:</strong></td><td>${record.rf_id}</td></tr>
                        <tr><td><strong>Gender:</strong></td><td>${record.gender}</td></tr>
                        <tr><td><strong>Animal Type:</strong></td><td>${record.species}</td></tr>
                        <tr><td><strong>Lactating/Young:</strong></td><td>${record.reproductive_status}</td></tr>
                        <tr><td><strong>Last Detail Location:</strong></td><td>${record.caught_location}</td></tr>
                        <tr><td><strong>Last Vaccination Date:</strong></td><td>${this.convertDate(record.caught_date)}</td></tr>
                        <tr><td><strong>Note:</strong></td><td>${record.note || 'N/A'}</td></tr>
                    </table>
                </div>
            `;
        }
    },
    mounted() {
        let vm = this;

        vm.activeAreaName = "> Area (" + localStorage.getItem('VaccinationAreaName') + ")";
        vm.selectedAreaId = localStorage.getItem('VaccinationAreaId');
        vm.project = vm.$store.getters.getCurrentSelectedProject;

        try {
            setTimeout(function () {
                var x = document.getElementsByTagName("label")[0].textContent = "";
            }, 50);
        } catch (e) {
        }

        vm.getArea();
        vm.getRecords();
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.startDatePast = firstDay.toLocaleDateString('en-US');
        this.endDatePast = lastDay.toLocaleDateString('en-US');
        this.dateRangePresets = this.getDateRangePresets();
    },
    watch: {
        filterByDate: function (val) {
            if (val) {
                this.datePickerStyleClass = 'col-xs-12 col-md-4 col-xl-4';
            } else {
                this.datePickerStyleClass = 'col-xs-12 col-md-2 col-xl-2';
            }
        }
    }
}

</script>
<style lang="scss" scoped>

.setShadow {
    box-shadow: 0 6px 10px 0px rgba(0, 0, 0, 0.15) !important;
}

.btn {
    margin: 0px !important;
}

@media (min-width: 1440px) and (max-width: 1441px) {
    .col-xl-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 22% !important;
    }
}

.img_marker_popup {
    height: 70px;
    width: 70px;
}

.set_redius {
    border-radius: 0px !important;
    background: transparent !important;
}

.set_p_btn {
    /* background-color: darkgrey; */
    background-color: white;
    margin-bottom: 10px;
}

.p_font {
    font-size: 17px;
}

.span_font {
    font-size: 13px;
}

.label-color {
    width: 12px;
    height: 12px;
    margin-bottom: 0px !important;
    border-radius: 3px;
    margin-right: 5px;
}

.legend-div {
    margin: 0px 0px 8px 0px;
}

.type-span {
    margin-right: 5px;
    font-size: 15px;
}

.close-icon {
    font-size: 32px;
}

.set_div_maps {
    top: 34%;
    left: 5%;
    position: absolute;
    z-index: 1;
    opacity: 1.5;
    width: 25%;
    border: 1px solid #ddd;
}

@media (min-width: 768px) and (max-width: 1200px) {
    .set_div_maps {
        top: 31%;
        left: 7%;
    }
}

@media (min-width: 320px) and (max-width: 767px) {
    .set_div_maps {
        top: 48%;
        left: 9%;
        position: absolute;
        z-index: 1;
        opacity: 1.5;
        width: 42%;
        border: 1px solid #ddd;
    }
}

.datepicker {
    z-index: 9999;
}
</style>
